/* eslint-disable @typescript-eslint/no-unused-vars */
import { FunctionComponent, ReactElement, useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { apiClient } from '../../adapters/api-client';
import { Housing } from '../../adapters/api-client/referential/Referential.model';
import { BaseInputDS, GenderInput, GenderInputDS, SelectedButton } from '../../components/DesignSystem';
import { LogementStatus } from '../../constants/constants';
import { useFetch } from '../../hooks/useFetch';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { checkFuturDate, checkYearDateFullfilled } from '../../utils/DateUtils';
import { ValidityHtmlElement } from '../../utils/DsType';
const Container = styled.div`
  base-input {
    --width-component: 110px;
  }
`;

const Logement: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { housing },
    logementValue,
    dispatch,
    apiStatus,
    dispatchLogementValue,
  } = useContext(store);
  const logementModeRef = useRef<GenderInputDS>(null);
  const logementDateRef = useRef(null);
  const { response: housings } = useFetch(() => apiClient().referential.getHousings());
  const onLogementChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!logementModeRef && logementModeRef.current !== null) {
      (logementModeRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ housing: { housingCode: e.currentTarget?.value } }));
      dispatchLogementValue(LogementStatus.AUTRE);
      if (e.currentTarget?.value === 'L') {
        dispatchLogementValue(LogementStatus.LOCATAIRE);
      }
    }
  };

  const onLogementDateChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ housing: { housingData: e.currentTarget?.value } }));
  };
  useEffect(() => {
    if (!!logementModeRef && logementModeRef.current !== null) {
      logementModeRef.current.value = housing?.housingCode || '';
    }
  }, [apiStatus]);

  useEffect(() => {
    if (!!logementDateRef && logementDateRef.current !== null) {
      (logementDateRef.current as unknown as BaseInputDS).customValidityPattern = [
        // {
        //   regexp: () =>
        //     checkNewerThanBirthdayYear(
        //       birthInfo?.birthDate,
        //       (logementDateRef.current as unknown as BaseInputDS)?.value as string,
        //     ),
        //   errorMessage: `Vérifiez l'année, elle ne semble pas exacte.`,
        // },
        {
          regexp: () => checkFuturDate((logementDateRef.current as unknown as BaseInputDS)?.value as string),
          errorMessage: `Vérifiez l'année, elle ne semble pas exacte.`,
        },
        {
          regexp: () => checkYearDateFullfilled((logementDateRef.current as unknown as BaseInputDS)?.value as string),
          errorMessage: `Le format de la date est incorrect (ex: 2012).`,
        },
        { regexp: '.+', errorMessage: `Veuillez renseigner l'année d'entrée dans votre logement actuel.` },
      ];
    }
  }, [logementDateRef.current]);
  return (
    <>
      <Container>
        <GenderInput
          ref={logementModeRef}
          label=""
          class="to-validate trackable-click"
          data-id="logementMode"
          onSelectedElementChange={onLogementChange}
          value={housing?.housingCode || ''}
          error-message="Veuillez choisir votre mode d'habitation."
        >
          {housings &&
            housings.map(({ code, label }: Housing) => (
              <SelectedButton key={code} value={code} secondary>
                {label}
              </SelectedButton>
            ))}
        </GenderInput>
      </Container>
    </>
  );
};

export default Logement;
